import { render } from "./keepItSimpleIcon.svg?vue&type=template&id=6c6635bc"
const script = {}
script.render = render

export default script